<app-asset-tag-list
  [tags]="assetTags()"
  [canEditTag]="canEditTag()"
  [clickable]="true"
  (clicked)="editTag($event.tag)"
  (remove)="removeTagFromAsset($event.tag, $event.event)"
>
  <app-asset-tag-select
    [tags]="allTags()"
    [unavailableTags]="assetTags()"
    [canCreate]="canCreate()"
    (add)="addTagToAsset($event)"
    [addTextPlaceholder]="'Add a tag...'"
  ></app-asset-tag-select>
</app-asset-tag-list>
